export const styles = {
  strip: (isLg, isGreaterSm) => ({
    backgroundColor: isLg ? null : 'white',
    borderRadius: '32px',
    padding: isGreaterSm ? '16px 30px 16px 30px' : '0 0 0 0',
  }),
  card: (isSm) => ({
    display: 'flex',
    alignItems: 'center',
    gap: isSm ? '12px' : '16px',
  }),
  text: (isSm) => ({
    fontWeight: 400,
    fontSize: isSm ? '14px' : '16px',
    letterSpacing: isSm ? '-0.01em' : undefined,
  }),
  section: {
    backgroundColor: { xs: 'white', md: 'kit.background.gray' },
    paddingTop: { xs: 3, md: 4 },
    paddingBottom: { xs: 4, md: 5 },
    '> div': {
      paddingLeft: {
        lg: '20px',
        xl: '30px',
      },
      paddingRight: {
        lg: '20px',
        xl: '30px',
      },
    },
  },
};
